export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11241.7aaf41d6.jpg";